import { defineStore } from 'ui.vue3.pinia';

export const useCoursesStore = defineStore("coursesnoauths", {
    state: () => ({
        list: [],              // текущий список курсов с фильтрами
        total: 0,              // всего курсов по фильтру
        filters: {},           // текущие фильтры (на будущее сделал может пригодиться фильтры)
        page: 1,               // текущая страница (на будущее для пагинации, пока у нас нет пагинации)
        perPage: 6,             // курсов на странице
        courseCode: null,
        courseGroup: null,
        detail: {},
    }),

    getters: {
        count: (state) => state.list.length,
        getById: (state) => (id) => state.list.find(course => course.ID === id),
        totalPages: (state) => Math.ceil(state.total / state.perPage)
    },

    actions: {
        async fetchCourses() {
            try {
                const response = await BX.ajax.runComponentAction("gk:courses.catalog", "getCourses", {
                    mode: 'class',
                    data: {
                        page: this.page,
                        perPage: this.perPage,
                        filters: this.filters
                    }
                });

                this.list = response.data || [];
                this.total = response.data.total || 0;
            } catch (error) {
                console.error("Ошибка загрузки курсов:", error);
            }
        },
        async fetchCourseDetail() {
            try {
                const response = await BX.ajax.runComponentAction("gk:courses.catalog", "getCourse", {
                    mode: 'class',
                    data: {
                        code: this.courseCode,
                        group: this.courseGroup
                    }
                }).then(r => r.data);
                if (response.status === 'success')
                    this.detail = response.detail;
            } catch (error) {
                console.error("Ошибка загрузки курса:", error);
            }
        }
    }
});